module.exports = __webpack_public_path__ + "img/li.li637cad1.svg";